export const API_BASE = (process.env.REACT_APP_API_URL || "http://localhost:5500").replace(/\/$/, "");

export const resolveImageUrl = (url: string | null | undefined): string => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${API_BASE}${url}`;
};
